import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { registerField } from 'core/forms';

import { RadioInput, DependentRadioSets } from 'uikit/inputs';

import styles from '../styles/formFieldDependantRadioSets.module.scss';

const FormFieldDependantRadioSets = ({ 
  fieldId, 
  fieldKey, 
  schema = {}, 
  value = {},
  updateField 
}) => {
  const radioSets = schema.sets?.map((set) => {
    const [key, options] = Object.entries(set)[0];

    return (
      <RadioInput
        className={styles.radioInput}
        key={key}
        fieldId={`${fieldId}-${key}`}
        fieldKey={`${fieldKey}.${key}`}
        options={options.map(option => ({
          value: option,
          label: i18n.t(option),
        }))}
        value={value?.[key] || schema.defaultInputValue || ''}
        updateField={(val) => {
          updateField({
            ...value,
            [key]: val,
          });
        }}
      />
    );
  });

  return (
    <DependentRadioSets
      className={schema.className}
      radioSets={radioSets}
    />
  );
};

FormFieldDependantRadioSets.propTypes = {
  fieldId: PropTypes.string.isRequired,
  fieldKey: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    sets: PropTypes.arrayOf(PropTypes.shape({})),
    className: PropTypes.string,
  }),
  value: PropTypes.shape({}),
  updateField: PropTypes.func.isRequired,
};

registerField('DependantRadioSets', React.memo(FormFieldDependantRadioSets));

export default FormFieldDependantRadioSets;
